export default "__VITE_ASSET__ByeEbdjg__"